class ujTermeklistaUjarvalaszto {

    changeDarab(el, fixDB)
    {
        var baseInput = $(el).parents('.kiszereles-darabszam-select-kont').find('.darabszam-input-kont .darabszam-input input');

        var selectedKiszerelesId = $(baseInput).data('aktkiszereles');
        var baseArakPanel = $(el).parents('.podor-product').find('.kiszereles-arak-kont .prices-kont[data-kiszereles="' + selectedKiszerelesId + '"]');

        if (!fixDB)
        {
            var aktDarabszam = +$(baseInput).val();

            if ($(el).hasClass('plus'))
            {
                if (
                    $("html").data('locale') == 'en_AU'
                    || $("html").data('locale') == 'fr_FR'
                )
                {
                    var kiszRaktarkeszlet = $(baseArakPanel).data('raktarkeszlet')
                    if (kiszRaktarkeszlet != '' && +kiszRaktarkeszlet > 0)
                    {
                        aktDarabszam = Math.min(kiszRaktarkeszlet, aktDarabszam + 1);
                        if (aktDarabszam >= kiszRaktarkeszlet)
                        {
                            aktDarabszam = kiszRaktarkeszlet;
                            $(el).addClass('disable-button');
                        }
                    } else {
                        aktDarabszam += 1;
                    }
                } else if ($("html").data('locale') == 'hu_HU') {

                    if ($(el).parents('.content').find('.pontert-megvasarolom').length > 0) {
                        aktDarabszam += 1;

                        var max_order_limit = +$(el).parents('.content').find('.pontert-megvasarolom .price').data('max_order_limit');
                        var maxLimit = +max_order_limit;

                        if (maxLimit > 0) {
                            // aktDarabszam = Math.min(maxLimit, aktDarabszam + 1);
                            if (aktDarabszam > maxLimit) {
                                $(el).parents('.content').find('.pontert-megvasarolom .btn').addClass('btn-disabled').attr('disabled', 'disabled');
                            } else {
                                $(el).parents('.content').find('.pontert-megvasarolom .btn').removeClass('btn-disabled').removeAttr('disabled');
                            }
                        } else {
                            $(el).parents('.content').find('.pontert-megvasarolom .btn').removeClass('btn-disabled').removeAttr('disabled');
                        }
                    } else {
                        aktDarabszam += 1;
                    }
                } else {
                    aktDarabszam += 1;
                }

            } else {

                if ($("html").data('locale') == 'hu_HU') {

                    if ($(el).parents('.content').find('.pontert-megvasarolom').length > 0) {
                        if (aktDarabszam > 1)
                        {
                            $(el).parents('.darabszam-input').find('.plus').removeClass('disable-button');
                            aktDarabszam -= 1;
                        }

                        var max_order_limit = +$(el).parents('.content').find('.pontert-megvasarolom .price').data('max_order_limit');
                        var maxLimit = +max_order_limit;
                        if (maxLimit > 0) {
                            // aktDarabszam = Math.min(maxLimit, aktDarabszam + 1);
                            if (aktDarabszam > maxLimit) {
                                $(el).parents('.content').find('.pontert-megvasarolom .btn').addClass('btn-disabled').attr('disabled', 'disabled');
                            } else {
                                $(el).parents('.content').find('.pontert-megvasarolom .btn').removeClass('btn-disabled').removeAttr('disabled');
                            }
                        } else {
                            $(el).parents('.content').find('.pontert-megvasarolom .btn').removeClass('btn-disabled').removeAttr('disabled');
                        }
                    } else {
                        if (aktDarabszam > 1)
                        {
                            $(el).parents('.darabszam-input').find('.plus').removeClass('disable-button');
                            aktDarabszam -= 1;
                        }
                    }
                } else {
                    if (aktDarabszam > 1)
                    {
                        $(el).parents('.darabszam-input').find('.plus').removeClass('disable-button');
                        aktDarabszam -= 1;
                    }
                }

            }

            if (isNaN(+baseInput.val()))
            {
                aktDarabszam = 1;
            }


            $(baseInput).val(aktDarabszam)

        } else {
            var aktDarabszam = fixDB;
        }

        var arSzamol = $(baseArakPanel).find('[data-calculate]');

        var arMin = 99999, arMax = 0;
        $.each(arSzamol, function (i, inp) {
            var arValue = +$(inp).data('calculate');

            if (arValue > 0) {
                arMin = Math.min(arMin, arValue);
                arMax = Math.max(arMax, arValue);

                var newValue = 0;
                var newValue_text = "";

                newValue = aktDarabszam * arValue;

                if ($(inp).data('type-point') == 1) {
                    newValue_text = Kosar.number_format(newValue, 0, ".", " ");
                } else {
                    if ($("html").data('locale') == 'hu_HU') {
                        newValue_text = Kosar.number_format(newValue, 0, ".", " ") + " Ft";
                    } else if ($("html").data('locale') == 'de_DE') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    } else if ($("html").data('locale') == 'sk_SK') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    } else if ($("html").data('locale') == 'sl_SI') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    } else if ($("html").data('locale') == 'en_EU') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    } else if ($("html").data('locale') == 'fr_FR' || $("html").data('locale') == 'fr_BE') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                        newValue_text = newValue_text.replace(",00", "");
                    } else if ($("html").data('locale') == 'cs_CZ') {
                        newValue_text = Kosar.number_format(newValue, 0, ",", " ") + " Kč";
                    } else if ($("html").data('locale') == 'pl_PL') {
                        newValue_text = Kosar.number_format(newValue, 2, ",", " ") + " zł";
                    } else if ($("html").data('locale') == 'en_US') {
                        newValue_text = '$' + Kosar.number_format(newValue, 2, ".", ",");
                    } else if ($("html").data('locale') == 'en_AU') {
                        newValue_text = '$' + Kosar.number_format(newValue, 2, ".", ",");
                    }
                }

                $(inp).find('span').text(newValue_text);

            }
        });

        $.each(arSzamol, function(i, inp){
            if ($(inp).data('alkedvezmeny') == 1)
            {
                var newValue_text = "";
                var newValue = (arMax - arMin) * aktDarabszam;

                if ($("html").data('locale') == 'hu_HU')
                {
                    newValue_text = Kosar.number_format(newValue, 0,"."," ") + " Ft";
                } else if ($("html").data('locale') == 'de_DE') {
                    newValue_text = Kosar.number_format(newValue, 2,",",".") + " €";
                } else if ($("html").data('locale') == 'sl_SI') {
                    newValue_text = Kosar.number_format(newValue, 2,",",".") + " €";
                } else if ($("html").data('locale') == 'en_EU') {
                    newValue_text = Kosar.number_format(newValue, 2,",",".") + " €";
                } else if ($("html").data('locale') == 'cs_CZ') {
                    newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " Kč";
                } else if ($("html").data('locale') == 'pl_PL') {
                    newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " zł";
                } else if ($("html").data('locale') == 'en_US') {
                    newValue_text = '$' + Kosar.number_format(newValue, 2,".",",");
                } else if ($("html").data('locale') == 'en_AU') {
                    newValue_text = '$' + Kosar.number_format(newValue, 2,".",",");
                } else if ($("html").data('locale') == 'fr_FR' || $("html").data('locale') == 'fr_BE') {
                    newValue_text = Kosar.number_format(newValue, 2, ",", ".") + " €";
                    newValue_text = newValue_text.replace(",00", "");
                }

                $(inp).find('span').text(newValue_text);
            }
        });

        if ($(el).parents('.podor-product').find('.pontert-megvasarolhato-plecsni').length > 0)
        {
            const ertek = +$(el).parents('.podor-product').find('.pontert-megvasarolhato-plecsni').data('pont_ertek');
            if (ertek > 0)
            {
                const pontErtek = aktDarabszam * ertek;
                $(el).parents('.podor-product').find('.pontert-megvasarolhato-plecsni .ertek').text(pontErtek);
            }
        };
        return false
    }

    keyupDarab(el, ev)
    {
        var baseInput = $(el).parents('.kiszereles-darabszam-select-kont').find('.darabszam-input-kont .darabszam-input input');

        var pressed = ev.which || ev.keyCode;

        // felnyil
        if (pressed == 38)
        {
            var aktDarabszam = +$(baseInput).val();
            aktDarabszam += 1;
            $(baseInput).val(aktDarabszam)

        // lenyil
        } else if (pressed == 40) {
            var aktDarabszam = +$(baseInput).val();
            if (aktDarabszam > 1)
            {
                aktDarabszam -= 1;
            }
            $(baseInput).val(aktDarabszam)
        }

        if (isNaN(+baseInput.val()))
        {
            $(baseInput).val(1)
        }

        var plusButton = $(el).parents('.kiszereles-darabszam-select-kont').find('.darabszam-input-kont .plus')
        this.changeDarab(plusButton, +baseInput.val());

    }

    changeKiszereles(el)
    {
        $(el).parent().find('a').removeClass('selected');
        $(el).addClass('selected');


        var aktKiszId = $(el).data('kiszereles_id'),
            nagykiszer = +$(el).data('nagykiszer'),
            akcio_merteke_locon_marketing_kiskiszer = +$(el).data('akcio_merteke_locon_marketing_kiskiszer'),
            baseProdItem = $(el).parents('.podor-product'),
            baseKiszKont = $(el).parents('.podor-product').find('.kiszerelesek-kont'),
            baseInput = $(el).parents('.item').find('.darabszam-input-kont .darabszam-input input');

        baseInput.data('aktkiszereles', aktKiszId);

        $(el).parents('.podor-product').find('.kiszereles-arak-kont .prices-kont').addClass('hide');
        $(el).parents('.podor-product').find('.kiszereles-arak-kont .prices-kont[data-kiszereles="'+aktKiszId+'"]').removeClass('hide');

        var plusButton = $(el).parents('.item').find('.darabszam-input-kont .plus');
        this.changeDarab(plusButton, +baseInput.val());

        var aktDataTag = $(el).parents('.podor-product').find('.image-wrapper .picselector-kont').find('.imgchanger[data-kiszereles="'+aktKiszId+'"]');
        if (aktDataTag.length > 0)
        {
            var baseImgtag = $(el).parents('.podor-product').find('.image-wrapper .picselector-kont img');
            baseImgtag.attr({
                'src': aktDataTag.data('kepsrc'),
                'srcset': aktDataTag.data('kepsrcset')
            })
        }

        if ($(baseProdItem).find('.akcio-aktiv.egyedi-mintermek').length > 0)
        {
            var inaktKiszer = ""+$(baseKiszKont).data('inaktiv_kiszerelesek');
            var inaktKiszerData = inaktKiszer.split(',');

            $(baseProdItem).find('.akcio-aktiv.egyedi-mintermek, .akcio-aktiv.egyedi-szazalek').removeClass('hide')

            if (inaktKiszerData.length > 0)
            {
                inaktKiszerData.forEach(function(inki) {
                    if (inki == aktKiszId)
                    {
                        $(baseProdItem).find('.akcio-aktiv.egyedi-mintermek, .akcio-aktiv.egyedi-szazalek').addClass('hide');
                    }
                });
            }

        }

        if ($(baseProdItem).find('.akcio-aktiv.termeklogo-plecsni').length > 0)
        {
            if (nagykiszer == 1 && akcio_merteke_locon_marketing_kiskiszer == '')
            {
                $(baseProdItem).find('.akcio-aktiv.termeklogo-plecsni').addClass('hide');
            } else {
                if (akcio_merteke_locon_marketing_kiskiszer > 0)
                {
                    $(baseProdItem).find('.akcio-aktiv.termeklogo-plecsni').removeClass('hide');
                    akcio_merteke_locon_marketing_kiskiszer = "-" + Math.abs(akcio_merteke_locon_marketing_kiskiszer) + "%";
                    $(baseProdItem).find('.akcio-aktiv.termeklogo-plecsni span').text(akcio_merteke_locon_marketing_kiskiszer);
                }
            }
        }

        if ($(el).data('kiszereles_nincs_ar_erdeklodjon') == 1)
        {
            $(baseProdItem).find('.darabszam-input-kont, .kiszereles-arak-kont, .cartbutton-cont').addClass('hide');
            $(baseProdItem).find('.nincs-ar-erdeklodjon').removeClass('hide');
        } else {
            $(baseProdItem).find('.darabszam-input-kont, .kiszereles-arak-kont, .cartbutton-cont').removeClass('hide');
            $(baseProdItem).find('.nincs-ar-erdeklodjon').addClass('hide');
        }

        var aktKedvKiszBase = $('.kiszereles-arak-kont .prices-kont[data-kiszereles="' + aktKiszId + '"]',baseProdItem);

        if ($('.pontert-megvasarolom', aktKedvKiszBase).length > 0) {

            var pointvalue = +$('.pontert-megvasarolom .price[data-calculate]', aktKedvKiszBase).data('calculate');
            if (pointvalue > 0) {
                $('.pontert-megvasarolom', aktKedvKiszBase).removeClass('d-none');
            } else {
                $('.pontert-megvasarolom', aktKedvKiszBase).addClass('d-none');
            }
        }

        // $('.picselector-kont .imgchanger[data-kiszereles_id='+aktKiszId+']').trigger('click')


        return false
    }

    kosarBarak()
    {
        var datas = {}, maxNum = 0;

        datas['termek_id'] = $('input[name=termek_id]').val();
        datas['akt_termek_ar'] = $('[name="akt_termek_ar"]').val();
        datas['akt_termek_klub_ar'] = $('[name="akt_termek_klub_ar"]').val();
        datas['actcurrency'] = $('[name="actcurrency"]').val();
        datas['termek_data'] = {
            'kep': termekDirectData.felugro_kep,
            'nev': termekDirectData.felugro_nev
        };

        if (kozmetikaDesign)
        {
            datas["kozmetika"] = 1;
        }

        datas['sessdata'] = typeof shopSessData == 'undefined' ? '' : shopSessData;;

        // datas['debug'] = 1;


        var baseInput = $('.cart-select-box .kiszereles-darabszam-select-kont .darabszam-input-kont .darabszam-input input');
        var aktDarabszam = +$(baseInput).val();
        var selectedKiszerelesType = $(baseInput).data('aktkiszereles');

        datas['type_1'] = selectedKiszerelesType;
        datas['db_1'] = aktDarabszam;

        if (window.location.href.indexOf('navi4') != -1)
        {
            datas["upsalev2"] = 1;
        }

        var cart = $('.webshop-button-d2');


        if (aktDarabszam > 0) {


            var elo = baseInput;


            var self = $(elo);
            var imgclone = self.clone()
                .addClass('shrink')
                .offset({top: self.offset().top, left: self.offset().left})
                .css({'opacity': '0.5', 'position': 'absolute', 'overflow': 'hidden', 'z-index': '1000'})
                .appendTo($('body'));
            imgclone.animate({
                // 'width':0,
                // 'height':0,
                'top': cart.offset().top + 10,
                'left': cart.offset().left + 30
            }, 500, 'swing', function () {
                $(this).detach();
                $('.webshop-button-d2').addClass('changed');


                (function(datas){

                    if (typeof GTAGDataItem != "undefined" )
                    {
                        GTMDataPusher.listItemAddToCart(GTAGDataItem, aktDarabszam)
                        GtagDataPusher.listItemAddToCart(GTAGDataItem, aktDarabszam)
                    }

                    $.post('/kosar/ad', datas, function (res) {

                        $('.webshop-button-d2 .cart-num').text(res.kos.allproduct);

                        //$('.header .tools .shop .amount').text(res.kos.allproduct);
                        $('#kosarlink1 .amount, #kosarlink2 .amount, .header .tools .shop .amount').each(function(){
                            $(this).text(res.kos.allproduct);
                            if (+res.kos.allproduct > 9)
                            {
                                $(this).addClass('wider')
                            }
                        });

                        $(baseInput).val(1);
                        if ($('.cart-select-box .kiszerelesek-kont a[data-kiszereles_alapertelmezett="1"]').length > 0) {
                            $('.cart-select-box .kiszerelesek-kont a[data-kiszereles_alapertelmezett="1"]:first').trigger('click');
                        } else {
                            $('.kiszereles-arak-kont .kiszereles-ar:first').trigger('click');
                        }

                        $('#kosarlink1, #kosarlink2, #kosarlink3').attr('href', kosarShopURL);

                        //datas['res'] = res;
                        datas['posta_ingyenlimit'] = $('[name="posta_ingyenlimit"]').val() != "" ? $('[name="posta_ingyenlimit"]').val() : postaIngyenlimit;
                        datas['actcurrency'] = $('[name="actcurrency"]').val();

                        //window.location.reload()
                        //Kosar.loadIngyenlimit(datas);
                        Kosar.saveKosarToBrowser();
                    });
                })(datas);

                setTimeout(function () {
                    $('.webshop-button-d2').removeClass('changed');

                    Kosar.showSelectdialog(datas);

                }, 1100);


            });
        } else {

            $(baseInput).parent().addClass('shake-shake');
            setTimeout(function(){
                $(baseInput).parent().removeClass('shake-shake');
            }, 1100);
        }

        return false
    }

    pontertMegvasarolom(el)
    {


        return false;
    }
}

export default ujTermeklistaUjarvalaszto;
